export default __webpack_public_path__ + "static/media/TassAppLogoSimple.be796c3f.svg";